import React from 'react';
import './ResourceGuide.css';
import user from '../../Assets/Man.png';
import VideoPlay from '../VideoPlay/VideoPlay';


function ResourceGuide() {
  return (
    <div className='resource-guide'>
    <h4 className='create-class-title'>Resource Guide</h4>
      <div className='create-class-container'>
        <div className='resource-beyond-teacher-hub'>
          <img src={user} alt="User" className="user-icon" />
          <span className='teacher-hub-text'>BeyondSchool Teacher Hub</span>
        </div>
        <VideoPlay className='teacher-hub-video'/>
        <span className='teacher-hub-text2'>Teach on BeyondSchools: Plan, Publish, and 
        Promote an Engaging Class</span>

        <p className="upload-videos-inbox-text">Led by Beyondschools Community team and a lineup of our most successful teachers, this class is designed to set you up for success as a Beyondschools teacher by guiding you through the steps of creating a class on our platform.
        </p>
        <span className='teacher-hub-nav'>Go to Teacher Help Center</span>
       </div>
    </div>
  )
}

export default ResourceGuide